import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b00db5f")

_pushScopeId("data-v-4b00db5f")
const _hoisted_1 = { class: "w-full flex py-3 flex-col gap-y-4 city-exclude-radio" }
const _hoisted_2 = { class: "p-field-radiobutton gap-x-3 flex flex-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", {
  for: "radio-all",
  class: "cursor-pointer"
}, "All", -1)
const _hoisted_4 = { class: "p-field-radiobutton gap-x-3 flex flex-row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", {
  for: "radio-custom",
  class: "cursor-pointer"
}, "Custom", -1)
const _hoisted_6 = {
  key: 0,
  class: "w-full flex flex-col gap-y-4 pl-8"
}
const _hoisted_7 = {
  key: 0,
  class: "p-2"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "mb-2" }, "Item terpilih", -1)
const _hoisted_9 = { class: "items-center w-full flex flex-wrap" }
const _hoisted_10 = { class: "flex flex-row border border-gray-lp-400 rounded-full px-3 py-1 mr-2 mb-3 whitespace-no-wrap" }
const _hoisted_11 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z",
  fill: "#ABACAE"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_multiple_select_search = _resolveComponent("multiple-select-search")!
  const _component_custom_dropdown = _resolveComponent("custom-dropdown")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_custom_dropdown, {
      placeholder: "Pilih shipment ID",
      isDisabled: _ctx.disabled,
      isExpand: _ctx.isExpand,
      "onUpdate:isExpand": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isExpand = $event))
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_RadioButton, {
              onChange: _ctx.onChangeRadioValue,
              id: "radio-all",
              name: "All",
              value: "ALL",
              modelValue: _ctx.radioValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.radioValue = $event))
            }, null, 8, ["onChange", "modelValue"]),
            _hoisted_3
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_RadioButton, {
              onChange: _ctx.onChangeRadioValue,
              id: "radio-custom",
              name: "Custom",
              value: "CUSTOM",
              modelValue: _ctx.radioValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.radioValue = $event))
            }, null, 8, ["onChange", "modelValue"]),
            _hoisted_5
          ]),
          (_ctx.radioValue === 'CUSTOM')
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_multiple_select_search, {
                  "server-side": false,
                  "is-loading": _ctx.shipmentIdLoading,
                  "show-selected": false,
                  options: _ctx.shipmentIdOptions,
                  modelValue: _ctx.modelValue,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue = $event)),
                  keyName: "name",
                  keyValue: "prefix",
                  placeholder: "Pilih",
                  onFocus: _ctx.fetchShipmentId
                }, null, 8, ["is-loading", "options", "modelValue", "onFocus"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["isDisabled", "isExpand"]),
    (_ctx.modelValue.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("div", _hoisted_9, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modelValue, (item, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                _createVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(item.name) + " ", 1),
                  (!_ctx.disabled)
                    ? (_openBlock(), _createBlock("svg", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.removeSelect(item)),
                        class: "w-4 ml-2 cursor-pointer",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _hoisted_11
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})